import { useEffect } from "react";

import { Select } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";

import { CancelAllTasksFormItems } from "./FormComponents/CancelAllTaskFormItems";
import { CancelCampaignTypeFormItems } from "./FormComponents/CancelCampaignTypeFormItems";
import { CancelTaskTypeFormItems } from "./FormComponents/CancelTaskTypeFormItems";

import type { FormInstance } from "antd";

type FormItemProps = {
    formValues: Record<string, any>;
    form: FormInstance;
};
export function CancelTaskFormItems({ formValues, form }: FormItemProps): JSX.Element {
    const { cancelType } = formValues;

    // we need to reset the form fields when cancelType changes
    // this is a hack to get around our double storage, and making sure we don't have stale data
    useEffect(() => {
        form.setFieldsValue({ taskType: undefined, campaignChannel: undefined, campaign: undefined });
        // we only want to observe campaignChannel
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cancelType]);

    return (
        <>
            <RVFormFloatingLabelWrap
                name="cancelType"
                label="Cancellation Criteria"
                rules={[
                    {
                        required: true,
                        message: "Select cancellation criteria",
                    },
                ]}
            >
                <Select>
                    <Select.Option value="allTasks">All Tasks</Select.Option>
                    <Select.Option value="taskType">Task Type</Select.Option>
                    <Select.Option value="campaign">Campaign</Select.Option>
                </Select>
            </RVFormFloatingLabelWrap>
            {cancelType == "allTasks" && <CancelAllTasksFormItems />}
            {cancelType === "taskType" && <CancelTaskTypeFormItems />}
            {cancelType === "campaign" && <CancelCampaignTypeFormItems formValues={formValues} form={form} />}
        </>
    );
}
